import React, { Component } from 'react';
import { Container } from 'reactstrap';
import Layout from '../components/Layout';
import EmployeeForm from '../modules/EmployeeForm';

class NewEmployeePage extends Component {
  getConfig = () => {
    const { state } = this.props.location;
    if (!state) {
      return undefined;
    } else {
      return state;
    }
  };

  getInitialValues = () => {
    const initialValues = { showOnContact: true, photo: {} };
    const { state } = this.props.location;
    if (!state) {
      return initialValues;
    } else {
      return { ...initialValues, lang: state.lang };
    }
  };

  render() {
    return (
      <Layout>
        <Container>
          <h1>Nový zaměstnanec</h1>
          <EmployeeForm
            config={this.getConfig()}
            initialValues={this.getInitialValues()}
          />
        </Container>
      </Layout>
    );
  }
}

export default NewEmployeePage;



// WEBPACK FOOTER //
// ./src/pages/NewEmployeePage.js